@if (!this.isLoading) {
  <div>
    <div fxFlex="grow">
      <div fxLayout="row" class="content content-margin content-spacing">
        <div fxFlex></div>
        <div fxFlex="80%" fxLayout="column" fxLayoutAlign="center flex-start">
          <div class="eula-title">
            <h1>End User Licensing Agreement (EULA)</h1>
          </div>
          <iframe
            [src]="
              this.latestEulaInEffect.documentUrl + '#toolbar=0&navpanes=0'
                | safeUrl
            "
            width="100%"
            height="600px"
          ></iframe>
          <div class="eula-download">
            <button
              mat-flat-button
              color="primary"
              (click)="downloadEula()"
              aria-label="Download EULA"
            >
              <mat-icon color="primary" class="md-18">file_download</mat-icon>
              Download EULA
            </button>
          </div>
          <div class="eula-accept-text">
            <mat-checkbox
              color="primary"
              [(ngModel)]="this.isAcceptanceChecked"
            >
              <span
                >I accept the Lineup End User Licensing Agreement
              </span></mat-checkbox
            >
          </div>
          <div class="eula-accept-button">
            <button
              mat-flat-button
              color="primary"
              (click)="acceptEula()"
              [attr.title]="'Accept'"
              id="accept-button"
              [disabled]="!this.isAcceptanceChecked"
            >
              Accept
            </button>
          </div>
        </div>
        <div fxFlex></div>
      </div>
    </div>
  </div>
}
